import { TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';
import React, { Suspense } from 'react';

import { APP_NAME, APP_TEAM_NAME } from './constants';
import { ApiProvider, I18nContainer, OnlineTopBanner } from './containers';
import { ConfigurationProvider } from './contexts';
import type { AppConfiguration } from './models';
import { TopAreaStoreProvider } from './stores/TopAreaStore';

export type RootProps = AppConfiguration;

export const App: FC<RootProps> = (configuration) => (
  <ConfigurationProvider value={configuration}>
    <TestIdProvider
      team={APP_TEAM_NAME}
      project={APP_NAME}
    >
      <Suspense fallback={null}>
        <ApiProvider>
          <I18nContainer>
            <TopAreaStoreProvider>
              <OnlineTopBanner />
            </TopAreaStoreProvider>
          </I18nContainer>
        </ApiProvider>
      </Suspense>
    </TestIdProvider>
  </ConfigurationProvider>
);
